import { Box, Skeleton, Grid } from '@mui/material'

export default function MyProfileSkeleton() {
  return (
    <>
      <Grid container>
        <Grid item>
          <Skeleton
            variant='text'
            width={200}
            height={80}
          />
        </Grid>
      </Grid>
      <Grid
        container
        marginBottom={2}
      >
        <Grid item>
          <Skeleton
            variant='text'
            width={150}
            height={60}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          bgcolor: 'white',
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '20px',
          border: '1px solid #EEEEEE',
        }}
      >
        {/* Skeleton for Image Uploader */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <Skeleton
            variant='circular'
            width={150}
            height={150}
          />
        </Box>
        {/* Skeleton for Text Fields */}
        <Grid
          container
          spacing={2}
          marginBottom={2}
        >
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
        </Grid>
        {/* Skeleton for Buttons */}
        <Grid
          container
          justifyContent='flex-end'
          spacing={2}
        >
          <Grid item>
            <Skeleton
              variant='rectangular'
              width={150}
              height={40}
            />
          </Grid>
          <Grid item>
            <Skeleton
              variant='rectangular'
              width={150}
              height={40}
            />
          </Grid>
        </Grid>
      </Box>
      <Grid container>
        <Grid item>
          <Skeleton
            variant='text'
            width={200}
            height={80}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          bgcolor: 'white',
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '20px',
          border: '1px solid #EEEEEE',
          marginTop: '20px',
        }}
      >
        {/* Skeleton for Text Fields */}
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'50%'}
              height={80}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
        >
          <Skeleton
            variant='text'
            width={'20%'}
            height={60}
          />
        </Grid>
        {/* Skeleton for Buttons */}
        <Grid
          container
          justifyContent='flex-end'
          spacing={2}
        >
          <Grid item>
            <Skeleton
              variant='rectangular'
              width={150}
              height={40}
            />
          </Grid>
          <Grid item>
            <Skeleton
              variant='rectangular'
              width={150}
              height={40}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
